import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import { useIntl } from 'react-intl';
import type { QuoteWorkspaceType } from 'state/workspaces/model';
import { camelCaseToWords } from 'utils/string';

export interface SolveModeOwnProps {
  solvingMode: string | undefined;
  isMultipleSolvingMode: boolean;
  workspaceType: QuoteWorkspaceType;
}

export type SolveModeProps = SolveModeOwnProps;

export function SolveModeLabel({ solvingMode, isMultipleSolvingMode, workspaceType }: SolveModeOwnProps) {
  const { formatMessage } = useIntl();
  if (solvingMode === undefined) {
    return null;
  }

  const solvingModeId =
    workspaceType === 'static'
      ? isMultipleSolvingMode
        ? 'field.solveResults'
        : `field.${solvingMode}`
      : `field.dynamic.${solvingMode}`;
  const defaultSolvingMode = workspaceType === 'static' && solvingMode ? solvingMode : camelCaseToWords(solvingMode);

  return (
    <div title={formatMessage({ id: 'solveFor' })}>
      <FormattedMessage id={solvingModeId as IntlKey} defaultMessage={defaultSolvingMode ?? ''} />
    </div>
  );
}
